<script>
  /* global Global */
  import Header from '../common/Header.svelte';
  import MessageBox from '../common/MessageBox.svelte';
  import Input from '../common/Input.svelte';
  import Button from '../common/Button.svelte';
  import LoginWithGoogle from '../ui-components/LoginWithGoogle.svelte';
  import IconButton from '../common/IconButton.svelte';
  import Common from '../js/common.js';

  export let params = undefined;

  let lang;
  let mode;

  const user = JSON.parse(window.localStorage.getItem('user'));
  if (user) window.location.href = window.localStorage.getItem('previousPage') || './';

  const value = { username: undefined, password: undefined };

  let messageBox;

  document.addEventListener('keyup', event => {
    if (event.key === 'Enter') login();
  });

  function switchLanguage () {
    lang = lang !== 'en' ? 'en' : 'cs';
    window.localStorage.setItem('lang', lang);
  }

  function switchMode () {
    mode = mode !== 'light' ? 'light' : 'dark';
    window.localStorage.setItem('mode', mode);

    window.document.body.classList.toggle('dark');
    document.querySelector('meta[name="theme-color"]').setAttribute('content', mode !== 'dark' ? Global.color.primary : Global.color.primaryDark);
  }

  function back () {
    window.location.href = window.localStorage.getItem('previousPage') || './';
  }

  async function login () {
    messageBox = {
      cs: { color: 'blue', message: i18n.loginInProgress.cs },
      en: { color: 'blue', message: i18n.loginInProgress.en },
    };

    // eslint-disable-next-line no-undef
    const response = await fetch(`${Common.BACKEND_URL}/user/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(value),
    });

    if (response.ok) {
      const data = await response.text();

      window.localStorage.setItem('user', data);
      window.location.href = window.localStorage.getItem('previousPage') || './';
    } else {
      // eslint-disable-next-line no-constant-condition
      if (true || response.status === Common.UNAUTHORIZED) {
        messageBox = {
          cs: { color: 'red', message: i18n.invalidLoginCredentials.cs },
          en: { color: 'red', message: i18n.invalidLoginCredentials.en },
        };
      } else {
        messageBox = {
          cs: { color: 'red', message: i18n.unexpectedError.cs },
          en: { color: 'red', message: i18n.unexpectedError.en },
        };
      }
    }
  }

  const i18n = {
    pageTitle: {
      cs: `Přihlásit se | ${Global.project.name.cs}`,
      en: `Login | ${Global.project.name.en}`,
    },
    login: {
      cs: 'Přihlásit se',
      en: 'Login',
    },
    username: {
      cs: 'Přihlašovací jméno',
      en: 'Username',
    },
    password: {
      cs: 'Heslo',
      en: 'Password',
    },
    resetPassword: {
      cs: 'Obnovit heslo',
      en: 'Reset password',
    },
    cookies: {
      cs: 'Přihlášením souhlasíte s použitím souborů cookies.',
      en: 'By logging in you agree to the use of cookies.',
    },
    loginInProgress: {
      cs: 'Probíhá přihlašování...',
      en: 'Login in progress...',
    },
    invalidLoginCredentials: {
      cs: 'Neplatné přihlašovací údaje.',
      en: 'Invalid login credentials.',
    },
    unexpectedError: {
      cs: 'Neočekávaná chyba. `E200`',
      en: 'Unexpected error. `E200`',
    },
    accountNotFound: {
      cs: 'Účet nenalezen.',
      en: 'Account not found.',
    },
  };

  const projectCode = Global.project.code;

  if (params && params.failure) {
    messageBox = {
      cs: { color: 'red', message: i18n.accountNotFound.cs },
      en: { color: 'red', message: i18n.accountNotFound.en },
    };
  }
</script>

<svelte:head>
  <title> {i18n.pageTitle[lang]} </title>
</svelte:head>

<Header page='login' display={false} savePage={false} bind:lang bind:mode/>

<div class='login'>
  <div class='login-logo'>
    {#if projectCode === 'pbw'}
      <img class='login-logo-image' src='img/static/logo-pbw.svg' alt='Prague Baseball Week logo'/>
    {:else}
      <img class='login-logo-image' src='img/static/logo.svg' alt='Eurobaseball 2023 logo'/>
    {/if}
  </div>

  <div class='login-form'>
    <div class='login-form-box'>
      <div class='login-form-box-actions'>
        <IconButton icon='translate' onClick={switchLanguage} borderRadius='5px'/>

        <IconButton icon={mode !== 'dark' ? 'dark_mode' : 'light_mode'} onClick={switchMode} borderRadius='5px'/>

        <IconButton icon='close' onClick={back} borderRadius='5px'/>
      </div>

      <div class='login-form-box-title'>
        <div class='login-form-box-title-text'>
          {i18n.login[lang]}
        </div>
      </div>

      <div class='login-form-box-content'>
        <div class='login-form-box-content-message-box'>
          <MessageBox value={messageBox ? messageBox[lang] : undefined}/>

          {#if !messageBox}
            <div class='login-form-box-content-message-box-cookies'>
              <span class='material-icons'> cookie </span> {i18n.cookies[lang]}
            </div>
          {/if}
        </div>

        <div class='login-form-box-content-username'>
          <Input bind:value={value.username} label={i18n.username[lang]} icon='person'/>
        </div>

        <div class='login-form-box-content-password'>
          <Input bind:value={value.password} label={i18n.password[lang]} type='password' icon='lock'/>
        </div>

        <div class='login-form-box-content-button'>
          <Button value={i18n.login[lang]} onClick={login} icon='login'/>
        </div>

        <div class='login-form-box-content-login-with-google'>
          <LoginWithGoogle bind:lang/>
        </div>

        <!-- <div class='login-form-box-content-reset-password'>
          <a href='./#/reset-password'> {i18n.resetPassword[lang]} </a>
        </div> -->
      </div>
    </div>
  </div>
</div>

<style>
  .login {
    position: fixed;
    top: 0px;
    left: 0px;

    display: flex;

    width: 100%;
    height: 100%;

    z-index: 3;

    background: var(--primary);
  }

  .login-logo {
    display: flex;
    align-items: center;
    flex-grow: 1;

    width: calc(100% - 450px);

    padding: 7.5%;
  }

  .login-logo-image {
    width: 100%;
    height: 100%;
  }

  .login-form {
    flex-shrink: 0;

    width: 100%;
    height: 100%;
    max-width: 450px;

    background: var(--white);
  }

  .login-form-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 40px;

    height: calc(100% - 40px);

    padding: 20px;
  }

  .login-form-box-actions {
    position: absolute;
    top: 20px;
    right: 20px;

    display: flex;
    gap: 10px;
  }

  .login-form-box-title {
    display: flex;
    align-items: center;
    flex-grow: 1;

    width: 100%;

    font-family: var(--font-secondary);
    font-size: 48px;
    font-weight: bold;
  }

  .login-form-box-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .login-form-box-content-message-box {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 40px;
  }

  .login-form-box-content-message-box-cookies {
    text-align: center;

    font-size: 12px;
    font-weight: bold;

    color: var(--grey-7);
  }

  .login-form-box-content-message-box-cookies .material-icons {
    font-size: 12px;
  }

  :global(body.dark) .login {
    background: var(--primary-dark);
  }

  :global(body.dark) .login-logo {
    filter: brightness(88%);
  }

  :global(body.dark) .login-form {
    background: var(--grey-9);
  }

  :global(body.dark) .login-form-box-content-message-box-cookies {
    color: var(--grey-5);
  }

  /* :global(body.dark) .login-form-box-content-reset-password {
    color: var(--grey-6);
  }

  :global(body.dark) .login-form-box-content-reset-password a:hover {
    text-decoration-color: var(--grey-6);
  } */

  @media only screen and (max-width: 900px) {
    .login-logo {
      display: none;
    }

    .login-form {
      max-width: 100%;
    }
  }
</style>
